<template>
  <div class="mobile-modal">
    <div class="mobile-modal-content">
      <div class="mobile-modal-title">请先绑定手机</div>
      <div class="mobile-modal-form">
        <div class="modal-input-box">
          <input type="text" class="mobile-modal-input" placeholder="请输入缴费所用手机号码" v-model="mobile">
        </div>
        <div class="modal-input-box">
          <input type="text" class="mobile-modal-input" placeholder="请输入验证码" v-model="code">
          <div class="modal-input-btn" @click="getVerifyCode">{{second == 0 ? '获取验证码' : `${second}s`}}</div>
        </div>
      </div>
      <div class="mobile-modal-btn" @click="bindMobile">绑定</div>
    </div>
  </div>
</template>

<script>
    import {getInfo} from "../common/storage";

    export default {
        name: "bind-mobile",
        data() {
            return {
                mobile: null,
                code: null,
                second: 0,
                timer: null
            }
        },
        methods: {
            getVerifyCode() {
                if(this.second > 0) return;
                if(this.mobile) {
                    this.$axios.post('/activity-live-wlist/get-verify-code', {mobile: this.mobile}).then(res => {
                        if(res.error == 0) {
                            this.$toast("验证码已发送到您的手机");
                            this.countDown();
                        } else {
                            this.$toast(res.msg);
                        }
                    })
                } else {
                    this.$toast("请输入手机号码")
                }
            },
            countDown() {
                this.second = 59;
                this.timer = setInterval(() => {
                   if(this.second <= 0) {
                       clearInterval(this.timer);
                       this.timer = null;
                   } else {
                       this.second -= 1;
                   }
                }, 1000);
            },
            bindMobile() {
                if(!this.mobile) {
                    this.$toast("请输入手机号码");
                    return;
                }
                if(!this.code) {
                    this.$toast("请输入验证码");
                    return;
                }
                this.$axios.post('/activity-live-wlist/submit-info', {
                    mobile: this.mobile,
                    code: this.code
                }).then(res => {
                    if(res.error == 0) {
                        getInfo(user => {
                            this.$emit("bind", user);
                        }, true)
                    } else {
                        this.$toast(res.msg);
                    }
                })
            }
        }
    }
</script>

<style lang="less">

  .mobile-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.75);
  }
  .mobile-modal-content {
    padding: 40px;
    width: 670px;
    min-height: 600px;
    border-radius: 20px;
    background: url(../assets/mobile-back.jpg) center / cover no-repeat;
    transform: translateY(-20%);
  }
  .mobile-modal-title {
    margin-top: 40px;
    font-size: 64px;
    font-weight: 600;
    color: #fff;
  }
  .mobile-modal-form {
    margin-top: 64px;
  }
  .modal-input-box {
    display: flex;
    align-items: center;
    margin-top: 24px;
    padding: 16px 0;
    border-bottom: 1px solid rgba(255,255,255,.2);
    font-size: 28px;
  }
  .mobile-modal-input {
    flex: 1;
    height: 40px;
    background: transparent;
    line-height: 40px;
    color: #fff;
    /*设置input textarea placeholder默认颜色和字体*/
    &::-webkit-input-placeholder { /* WebKit browsers */
      color: rgba(255,255,255,.6);
      font-family: inherit;
    }
    &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      color: rgba(255,255,255,.6);
      font-family: inherit;
    }
    &::-moz-placeholder { /* Mozilla Firefox 19+ */
      color: rgba(255,255,255,.6);
      font-family: inherit;
    }
    &:-ms-input-placeholder { /* Internet Explorer 10+ */
      color: rgba(255,255,255,.6);
      font-family: inherit;
    }
  }
  .modal-input-btn {
    color: #00FFEE;
  }
  .mobile-modal-btn {
    margin: 100px 0 40px;
    height: 88px;
    border-radius: 88px;
    background-color: #fff;
    line-height: 88px;
    text-align: center;
    font-weight: 600;
    font-size: 36px;
    color: #099AFF;
    &:active {
      background-color: #eee;
    }
  }
</style>
